import { useTransition } from '..';
export function Transition({ state, timeout, children }) {
    const { stage, shouldMount } = useTransition(state, timeout);
    return children(stage, shouldMount);
}
